interface Config {
  startupClientUrl: string;
  startupApiUrl: string;
  investorClientUrl: string;
  investorApiUrl: string;
  mySpaceClientUrl: string;
  mySpaceApiUrl: string;
  innovateClientUrl: string;
  innovateApiUrl: string;
  aiApiUrl: string;
  domain: string;
  version: string;
  environment: string;
  isDebug: boolean;
  tossClientKey: string;
}

export const config: Config = {
  startupClientUrl: import.meta.env.VITE_CLIENT_URL_STARTUP || 'http://localhost:3000',
  startupApiUrl: import.meta.env.VITE_API_URL_STARTUP || 'http://localhost:3001',
  investorClientUrl: import.meta.env.VITE_CLIENT_URL_INVESTOR || 'http://localhost:3002',
  investorApiUrl: import.meta.env.VITE_API_URL_INVESTOR || 'http://localhost:3003',
  mySpaceClientUrl: import.meta.env.VITE_CLIENT_URL_MY_SPACE || 'http://localhost:3004',
  mySpaceApiUrl: import.meta.env.VITE_API_URL_MY_SPACE || 'http://localhost:3005',
  innovateClientUrl: import.meta.env.VITE_CLIENT_URL_INNOVATE || 'http://localhost:3006',
  innovateApiUrl: import.meta.env.VITE_API_URL_INNOVATE || 'http://localhost:3007',
  aiApiUrl: import.meta.env.VITE_API_URL_AI || 'http://localhost:3009',
  domain: import.meta.env.VITE_DOMAIN || 'http://localhost:3000',
  version: import.meta.env.VITE_VERSION || '0.0.0',
  environment: import.meta.env.VITE_NODE_ENV || 'development',
  isDebug: import.meta.env.VITE_DEBUG === 'true',
  tossClientKey: import.meta.env.VITE_TOSS_CLIENT_KEY || '',
};

export default config;
